import { fetchAllCourses, fetchCourseInfo } from "@/api/landing";
import { generateRandomGradient } from "@/utils/gradients";

export default {
  namespaced: true,
  state: {
    allCourses: {
      data: [],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 10,
        lastPage: 1,
        nextPage: null,
      },
    },
    courseInfo: {},
    branchReviews: [],
    gradients: [],
  },

  mutations: {
    SET_ALL_COURSES(state, payload) {
      const coursesData = payload.data || [];
      
      state.allCourses.data = coursesData;
      state.allCourses.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
        nextPage: payload.next_page_url,
      };

      if (coursesData.length > 0) {
        if (
          state.gradients.length === 0 ||
          state.gradients.length !== coursesData.length
        ) {
          state.gradients = coursesData.map((_, index) =>
            generateRandomGradient(index)
          );
        }
      } else {
        state.gradients = [];
      }
    },
    SET_COURSE_INFO(state, courseInfo) {
      state.courseInfo = courseInfo;
    },
    SET_BRANCH_REVIEWS(state, reviews) {
      state.branchReviews = reviews;
    },
    SET_COURSE_GRADIENTS(state, gradients) {
      state.gradients = gradients;
    },
  },

  actions: {
    loadAllCourses({ commit }, { page = 1, filters = {} } = {}) {
      return fetchAllCourses({ page, ...filters })
        .then((response) => {
          if (response && response.data) {
            const coursesData = response.data.data || [];
            const coursesWithBackground = {
              ...response.data,
              data: coursesData.map((course, index) => ({
                ...course,
                background: generateRandomGradient(index),
              })),
            };
            commit("SET_ALL_COURSES", coursesWithBackground);
          } else {
            commit("SET_ALL_COURSES", { data: [] });
          }
        })
        .catch((error) => {
          console.error("Ошибка загрузки курсов:", error);
          commit("SET_ALL_COURSES", { data: [] });
          return Promise.reject(error);
        });
    },

    loadCourseInfo({ commit }, courseId) {
      return fetchCourseInfo(courseId)
        .then((response) => {
          commit("SET_COURSE_INFO", response.data.course_info);
          commit("SET_BRANCH_REVIEWS", response.data.branch_reviews);
        })
        .catch((error) => {
          console.error("Ошибка загрузки информации о курсе:", error);
          return Promise.reject(error);
        });
    },
  },

  getters: {
    getAllCourses: (state) => state.allCourses,
    getPagination: (state) => state.allCourses.pagination,
    getCourseInfo: (state) => state.courseInfo,
    getBranchReviews: (state) => state.branchReviews,
    getGradients: (state) => state.gradients,
  },
};
